import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import SettingsPersonalFormsFormOther from 'lumen/components/settings/personal/forms/form-other';
import SettingsPersonalFormsFormUserEdit from 'lumen/components/settings/personal/forms/form-user-edit';
import hasFeature from 'lumen/helpers/has-feature';
import type HotelSettingsPersonalRoute from 'lumen/routes/hotel/settings/personal';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsPersonalSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsPersonalRoute>;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.personal.description"}}
    @title={{t "settings.personal.title"}}
    @type="container"
  >
    <div class="my-account">
      <SettingsPersonalFormsFormUserEdit />

      {{#if (hasFeature "user.personal_settings.edit.other")}}
        <SettingsPersonalFormsFormOther
          @highlightConfig={{@model.highlightConfig}}
        />
      {{/if}}
    </div>
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsPersonalSignature>;
